var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeedometerinline = function SvgSpeedometerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.008 22c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Z",
    fill: "#7D64FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#speedometer_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.782 12.153c.634-.635.418-1.705-.45-1.93a13.225 13.225 0 0 0-3.324-.422c-7.29 0-13.2 5.91-13.2 13.2 0 4.212 1.973 7.964 5.046 10.38a.7.7 0 0 0 .388.154v.002h15.54v-.003a.7.7 0 0 0 .38-.152A13.177 13.177 0 0 0 35.208 23c0-1.15-.147-2.266-.424-3.33-.225-.867-1.295-1.083-1.93-.45-.332.333-.446.821-.337 1.279.19.802.29 1.64.29 2.5 0 3.246-1.43 6.157-3.696 8.137H14.905A10.775 10.775 0 0 1 11.208 23c0-5.965 4.835-10.8 10.8-10.8.86 0 1.695.1 2.496.29.457.108.945-.006 1.278-.338Zm-1.654 13.263h.001c.345-.346.599-.767.853-1.187.127-.211.254-.422.392-.623l5.907-8.583a.721.721 0 0 0-1.003-1.003l-8.583 5.908c-.201.139-.412.266-.622.393-.42.253-.841.507-1.186.852h-.001a3 3 0 0 0 4.242 4.243Z",
    fill: "url(#speedometer_inline_svg__b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "speedometer_inline_svg__b",
    x1: 22.011,
    y1: 9,
    x2: 22.011,
    y2: 34.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fff",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "speedometer_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.008 8)",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgSpeedometerinline;